"use client";

import { useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { isOneOf } from "@shared/type-guards";
import { inquiryTypes, type InquiryType } from "@/lib/validation/schemas";
import { contactPageFormDefaultValues } from "@/lib/validation/defaults";

const SALES_INTENT_PARAMS = ["demo", "source", "plan"] as const;

function inquiryFromParams(typeParam: string | null, searchParams: URLSearchParams): InquiryType {
  if (typeParam === "enterprise") return "sales";
  if (typeParam && isOneOf(inquiryTypes, typeParam)) return typeParam;
  if (SALES_INTENT_PARAMS.some((param) => searchParams.has(param))) return "sales";
  return contactPageFormDefaultValues.inquiryType;
}

function messageFromParams(
  typeParam: string | null,
  isEnterpriseLead: boolean,
  prefill: string | null,
): string {
  if (isEnterpriseLead && (typeParam === "buyer" || typeParam === "vendor")) {
    return `I'm interested in the Enterprise plan for ${typeParam === "buyer" ? "buyers" : "vendors"}. `;
  }
  if (isEnterpriseLead) {
    return "I'm interested in the Enterprise plan for a multi-location supplier. ";
  }
  return prefill ?? contactPageFormDefaultValues.message;
}

export function useContactFormPrefill() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const typeParam = searchParams.get("type");
  const pricingPlan = searchParams.get("plan");
  const isEnterpriseLead = pricingPlan === "enterprise";

  useEffect(() => {
    if (typeParam === "general") router.replace("/request-quote");
  }, [typeParam, router]);

  return {
    typeParam,
    pricingPlan,
    isEnterpriseLead,
    inquiryType: isEnterpriseLead ? ("sales" as const) : inquiryFromParams(typeParam, searchParams),
    message: messageFromParams(typeParam, isEnterpriseLead, searchParams.get("prefill")),
  };
}
